/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from 'react';
import Auth from '../shared/Auth';
import { toast } from 'react-toastify';
import sanitizeHtml from 'sanitize-html';
import Modal from 'react-bootstrap/Modal';
import { qreq } from '../shared/qrequest';
import Globals from '../shared/Globals';
import { v4 as uuidv4 } from 'uuid';
import SharedUtil from '../shared/SharedUtil';
import { ErrorAlert } from './ErrorAlert';
import { SidebarGlobal } from './_Sidebar';
import { Pop } from './PopModal';
import L from './Lang';

const allowedHTML = {
    parseStyleAttributes: false,
    allowedTags: ['table', 'thead', 'tbody', 'tr', 'td', 'th', 'div', 'span', 'b', 'i', 'strong', 'h1', 'h2', 'h3', 'h4', 'h5', 'hr', 'img', 'br', 'p', 'ul', 'ol', 'li'],
    allowedAttributes: {
        table: ['style', 'class'],
        b: ['style', 'class'],
        i: ['style', 'class'],
        strong: ['style', 'class'],
        div: ['style', 'class', 'varnote'],
        span: ['style', 'class'],
        tr: ['style', 'class'],
        td: ['style', 'class', 'colspan'],
        th: ['style', 'class', 'colspan'],
        a: ['href', 'target'],
        img: ['src', 'alt', 'style', 'class']
    },
    allowedSchemes: ['data', 'http', 'https']
};

const allowedCommentHTML = {
    parseStyleAttributes: false,
    allowedTags: ['br', 'p', 'b', 'i', 'strong', 'a', 'svg', 'path', 'table', 'thead', 'tbody', 'tr', 'td', 'th', 'span'],
    allowedSchemes: ['https', 'tel'],
    allowedAttributes: {
        a: ['href', 'target', 'onclick'],
        img: ['src', 'alt', 'style', 'class']
    }
};

export default class BaseCom extends React.Component {

    constructor(props, state) {
        super(props);
        if (!state)
            state = {};
        this.state = state;
        this.set = this.set.bind(this);
        this.get = this.get.bind(this);
        this.addToList = this.addToList.bind(this);
        this.removeFromList = this.removeFromList.bind(this);
        this.goBack = this.goBack.bind(this);
    }


    set(a, b) {
        var state = this.state;
        state[a] = b;
        this.setState(state);
    }

    setListItemValue = (stit, item, a, b) => {
        item[a] = b;
        this.setState({ [stit]: [...this.state[stit]] });
    }

    get(a) {
        return this.state[a];
    }

    addToList(list, obj) {
        if (!obj)
            obj = {};
        obj.key = list.length;
        list.push(obj);
        this.setState({ item: this.state.item });
    }

    removeFromList(list, obj) {
        if (list.indexOf(obj) === -1)
            return;
        list.splice(list.indexOf(obj), 1);
        this.setState({ item: this.state.item });
    }

    getLogin(callback, errorCallback) {
        Auth.getLogin(callback, errorCallback);
    }

    async getLoginAsync() {
        return new Promise((resolve, reject) => {
            Auth.getLogin((u) => {
                resolve(u);
            }, (e) => {
                reject(e);
            });
        });
    }

    requireLogin(successCallback) {
        Auth.requireLogin(successCallback);
    }

    alert = (msg) => {
        if (!msg) return;

        //if (Globals.isOutsidePath(document.location.pathname))
        //    this.toast().error(msg, { autoClose: 5000 });
        //else
        ErrorAlert.show(msg);
    }

    success(msg) {
        SidebarGlobal.success(msg);
    }

    warning(msg, interval) {
        SidebarGlobal.warning(msg);
    }

    goBack() {
        const prevHref = window.location.href;
        window.history.go(-1);

        setTimeout(function () {
            if (window.location.href === prevHref) {
                window.location.href = '/';
            }
        }, 500);
    }


    toast() {
        return toast;
    }

    unkownErrorCallback(e) {
        const unkMsg = 'Unknown error ocurred. Please try again.';
        if (e)
            console.error(e);
        if (Globals.isOutsidePath(window.location.pathname)) {
            //this.toast().error(unkMsg);
            this.alert(unkMsg);
        }
        else if (e) { // inside and e exists
            ErrorAlert.show(e.message);
        }
        else { // unknown
            //this.toast().error(unkMsg);
            this.alert(unkMsg);
        }
    }

    processHTML(html, allowLinks) {
        if (allowLinks) {
            var allowed = { ...allowedHTML, allowedTags: [...allowedHTML.allowedTags, 'a'] };
            return sanitizeHtml(html, allowed);
        }
        else
            return sanitizeHtml(html, allowedHTML);
    }

    processComment(html) {
        if (!html) return;
        return sanitizeHtml(html.replace(/\n/g, '<br />'), allowedCommentHTML);
    }

    capitalize(str) {
        if (str) {
            if (str.length > 0) {
                if (str.length === 1)
                    return str.toUpperCase();
                else {
                    if (str.indexOf(' ') >= 0) {
                        var arr = [];
                        var p = str.split(' ');
                        p.forEach(i => {
                            arr.push(this.capitalize(i));
                        });
                        return arr.join(' ');
                    }
                    return str[0].toUpperCase() + str.substring(1).toLowerCase();
                }
            }
        }
        return str;
    }

    wrapModal(children, title, size, show, onHide) {
        if (!show)
            show = this.props.show;
        if (!onHide)
            onHide = this.props.onHide;
        if (!show) return;
        return <Modal show={show} onHide={() => { if (onHide) onHide(); }} size={size}>
            {title ?
                <Modal.Header closeButton={onHide ? true : false}>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header> : ''}
            <Modal.Body>
                {children}
            </Modal.Body>
        </Modal>;
    }

    isMobile() {
        return window.innerWidth < 992;
    }

    getPhoneView(str) {
        var content = [];
        var regex = /(\d{3})[ -()]+(\d{3})[ -()]+(\d{4})/g;
        var matches = [...str.matchAll(regex)]
        matches.forEach(i => {
            str = str.replace(i[0], 'PHONE');
            content.push(<a href={'tel:' + i[1] + i[2] + i[3]}>{i[1]}-{i[2]}-{i[3]}</a>);
        });
        return <><div>{str}</div><div>{content}</div></>;
    }

    fillItem(api, vname, successCallback, errorCallback) {
        if (!vname) vname = 'item';
        qreq.get(api, j => {
            if (j.item) {
                this.setState({ [vname]: j.item });
                successCallback?.(j.item);
            }
            else {
                this.alert(j.errorMessage);
                errorCallback?.(j.errorMessage);
            }
        }, () => {
            this.unkownErrorCallback();
            errorCallback?.();
        });
    }

    fillItemAsync(api, vname) {
        return new Promise((resolve, reject) => {
            this.fillItem(api, vname, resolve, resolve);
        });
    }

    fillList(api, vname, usePost, successCallback, errorCallback) {
        if (usePost) {
            qreq.post(api, {}, j => {
                if (j.list) {
                    this.setState({ [vname]: j.list });
                    successCallback?.(j.list);
                }
                else {
                    this.alert(j.errorMessage);
                    errorCallback?.(j.errorMessage);
                }
            }, () => {
                this.unkownErrorCallback();
                errorCallback?.();
            });
        }
        else {
            qreq.get(api, j => {
                if (j.list) {
                    this.setState({ [vname]: j.list });
                    successCallback?.(j.list);
                }
                else {
                    this.alert(j.errorMessage);
                    errorCallback?.(j.errorMessage);
                }
            }, () => {
                this.unkownErrorCallback();
                errorCallback?.();
            });
        }
    }

    fillListAsync(api, vname, usePost) {
        return new Promise((resolve, reject) => {
            this.fillList(api, vname, usePost, resolve, resolve);
        });
    }

    async getAsync(api, data) {
        try {
            let j = await qreq.getAsync(api, data);
            return j;
        }
        catch (e) {
            console.error(e);
            return null;
        }
    }

    async postAsync(api, data) {
        try {
            let j = await qreq.postAsync(api, data);
            return j;
        }
        catch (e) {
            console.error(e);
            return null;
        }
    }

    async postActionAsync(api, data) {
        let j = await qreq.postAsync(api, data);
        return (j.errorCode === 0);
    }

    async componentDidMount() {
        this.applyThemeColors();
    }

    componentDidUpdate() {
        if (!Globals.isOutsidePath(document.location.pathname) && document.location.pathname.startsWith('/client'))
            this.applyThemeColors(null, null, true);    // this is questionable
    }

    darkenColor(color) {
        var dec = parseInt(color.replace('#', ''), 16);
        return '#' + (dec - 30).toString(16).padStart(6, '0');;
    }

    applyThemeColors = () => {
        Auth.getLogin(u => {
            if (u && u.organization)
                this.setThemeColors(u.organization.primaryColor, u.organization.secondaryColor);
        });
    }

    setThemeColors(primaryColor, secondaryColor, noRedo) {
        //const primaryBtnColor = this.darkenColor(primaryColor);
        //const secondaryBtnColor = this.darkenColor(secondaryColor);
        var divs = [
            ...document.getElementsByClassName('--bg-primary'),
            ...document.querySelectorAll('.table thead th'),
            ...document.querySelectorAll('.table thead th a'),
            ...document.querySelectorAll('.app-tabs')
        ];
        for (let i = 0; i < divs.length; i++) {
            const div = divs[i];
            div.style.backgroundColor = primaryColor;
        }
        divs = document.getElementsByClassName('--bg-secondary');
        for (let i = 0; i < divs.length; i++) {
            const div = divs[i];
            div.style.backgroundColor = secondaryColor;
        }
        divs = document.getElementsByClassName('--text-primary');
        for (let i = 0; i < divs.length; i++) {
            const div = divs[i];
            div.style.color = primaryColor;
        }
        if (!noRedo)
            setTimeout(() => this.setThemeColors(primaryColor, secondaryColor, true), 100);
    }

    async getSettings() {
        try {
            let ret = await Globals.getSettings();
            this.setState({
                publicSettings: ret,
                PUB: ret,
                UNI: ret.universal,
                MODEL: ret.instanceModel,
                MODELPROPS: ret.instanceModelProps,
                GEORESTRICT: ret.geoRestrict
            });
            return ret;
        }
        catch {
            return null;
        }
    }

    getSystemSettings = async () => {
        try {
            let j = await qreq.getAsync('/api/settings/get/system');
            if (j.item) {
                this.setState({ SETTINGS: j.item });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }


    blankValue(v) {
        if (!v) return null;
        return v;
    }

    getMainOrg = async (errorCallback) => {
        let org = await SharedUtil.getMainOrgAsync();
        if (org === -101) {
            if (errorCallback)
                errorCallback('Instance not found.');
        }
        else if (org) {
            this.setState({ org: org });
            return org;
        }
        else {
            if (errorCallback)
                errorCallback('Failed to get main org.');
            else
                console.error('Failed to get main org.');
        }
    }


    getMainOrgLogoURL = (dark) => {
        if (this.state.org?.logoURL)
            return Globals.getImageURL(this.state.org.logoURL);
        return '/img/logo-' + (dark ? 'd' : 'l') + '.png';
    }

    getParentElementWithClass = (el, cls) => {
        while (el && el.tagName !== 'BODY') {
            if (el.classList.contains(cls)) {
                return el;
            }
            el = el.parentElement;
        }
        return null;
    }

    uuid(v) {
        return uuidv4(v);
    }

    T(str) {
        return this.state.PUB?.[str + 'Label'];
    }

    async author() {
        try {
            await qreq.getAsync('/api/settings/author');
        }
        catch { }
    }

    async pullUserAsync() {
        return new Promise((resolve, reject) => {
            Auth.getLogin(u => {
                this.setState({ user: u });
                resolve(u);
            });
        });
    }

    getLogo = () => {
        if (this.state.user && this.state.user.organization && this.state.user.organization.logoURL)
            return Globals.getImageURL(this.state.user.organization.logoURL);
        return this.getMainOrgLogoURL();
    }

    enc(x) {
        return encodeURIComponent(btoa(x));
    }

    fileToDataURL(v) {
        if (v.thumbUrl)
            return Globals.serverUrl + v.thumbUrl;
        else if (v.url)
            return Globals.serverUrl + v.url;
        return 'data:' + v.fileType + ';base64,' + v.base64Content;
    }

    // CART

    getCart = async () => {
        try {
            let j = await qreq.getAsync('/api/cart/get');
            if (j.item) {
                Globals.set('cart', j.item);
                this.setState({ cart: j.item });
                return j.item;
            }
        }
        catch (e) {
        }
    }

    cartCheckout = async () => {
        try {
            let j = await qreq.postAsync('/api/cart/checkout', {});
            if (j.errorCode === 0) {
                this.props.navigate('/purchase-order/edit/' + j.item.id);
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    // CSS

    importCSS(href) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        link.dataset.dynamic = "true"; // Tag for later removal
        document.head.appendChild(link);
    }

    undefineCSS(href) {
        const links = document.querySelectorAll(`link[rel="stylesheet"][href="${href}"]`);
        links.forEach(link => link.remove());
    }

    // Logout

    logout = (e, followPath) => {
        e?.preventDefault();
        Pop.showConfirm(<L>Are you sure you want to logout?</L>, <L>Logout</L>, () => {
            window.location.assign('/logout' + (followPath ? '?follow=' + encodeURIComponent(followPath) : ''));
        });
    }

    // Query String

    qs = (name) => {
        const url = window.location.search.substring(1);
        const params = url.split('&');

        for (let p of params) {
            const [key, value] = p.split('=');
            if (key === name) return decodeURIComponent(value);
        }
        return null;
    }

    rehash = () => {
        this.setState({ hash: this.uuid() });
    }
}